import styles from './EllipsisTextLine.module.css'

const EllipsisTextLine = ({ children }) => {
	return <span className={styles.text_wrapper}>{children}</span>
}

export default EllipsisTextLine
